import { render, staticRenderFns } from "./moreLoadBox.vue?vue&type=template&id=cfa662b2&scoped=true&"
import script from "./moreLoadBox.vue?vue&type=script&lang=js&"
export * from "./moreLoadBox.vue?vue&type=script&lang=js&"
import style0 from "./moreLoadBox.vue?vue&type=style&index=0&id=cfa662b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa662b2",
  null
  
)

export default component.exports